module.exports = __webpack_public_path__ + "9c89f587f71426483e6bfe764220aa18.svg";